import React from 'react'
import { connect } from "react-redux"
import { withRouter } from 'react-router'
import Waypoint from 'react-waypoint';
import { Tooltip } from 'react-tippy';

import loaderImg from '../practice_admin/images/loader.gif'

import AssessmentForm from './AssessmentForm'
import PatientSessions from './PatientSessions'
import PatientDetailsForm from '../admin/PatientDetailsForm'
import ShowCategories from '../ui/ShowCategories'
import CategoryAreas from '../ui/CategoryAreas'
import Sidenav from '../sidenav/Sidenav';
import DocumentUpload from '../ui/DocumentUpload'
import FileImg from '../../images/icons/FileIcon'
import Avatar from '../user/Avatar'
import ReactHtmlParser from 'react-html-parser';

import { listenToUserSessionNotifications, unListenToUserSessionNotifications } from '../../actions/comments'
import {
	fetchSessions,
	deleteSession,
	saveSession,
	fetchTherapistPatients,
	createAssessment,
	fetchTherapistPatientRecord,
	fetchPatientAssessments,
	savePatient,
	setPractice,
	archiveTherapistPatient,
	unarchiveTherapistPatient
} from '../../actions/therapist'
import { setTitle, fetchTherapyAreas, fetchTherapyCategories,fetchVideos, setModal, fetchPracticeById } from "../../actions/index"
import { deleteDocument } from '../../actions/documents'
import { getGalleryItemsForPatient } from '../../actions/gallery'
import moment from 'moment'

import deleteSVG from './images/trash.svg'
import archiveSVG from './images/archive.svg'
import unArchiveSVG from './images/archive-open.svg'
import  plusSVG  from './images/plus-symbol.svg'

import eventbus from '../../store/eventbus'

let cleanNewAssessment = {
	'doa': new Date(),
	'therapy_areas': [],
	'documents': []
}

let cleanNewSession = {
	'therapy_areas': [],
	'videos': [],
	// 'created': new Date()
}

// @connect((store) => {
const mapStateToProps = store => {
	return {
		User: store.User.User,
		app: store.app,
		therapy_areas: store.therapy_areas,
		therapy_categories: store.therapy_categories,
		patients: store.patients,
		patient_records: store.patient_records,
		assessments: store.assessments,
		videos: store.videos,
		patient_sessions: store.patient_sessions,
		sessions: store.sessions,
		modal: store.modal,
		notifications: store.notifications,
		gallery: store.gallery,
	}
};
class TherapistPatient extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			'patient': {},
			'patientForm': {},
			'patientRecord': {},
			'newAssessment': { ...cleanNewAssessment },
			'gotPatients': false,
			'newAssessmentFormOpen': false,
			'editPatientOpen': false,
			'newSessionFormOpen': false,
			'newSessionSelectTherapyAreasOpen': false,
			'newSessionSelectVideosOpen': false,
			'newSession': { ...cleanNewSession },
			'patient_sessions_array': [],
			'patient_assessments_array': [],
			'patient_session_assessments_array': [],
			'whichSession': 'state',
			'showAssessment': false,
			'from': props.location.query.from || 0,
			'loading': true,
			'noMoreSessions': false,
			'blur': false,
			'startDate': moment(),
			'assessmentStartDate': moment(),
			'filterBy': 'all',
			'filterDate': null,
			'homework': null,
			'newSessionAssessmentMenu': false,
			'currenetAssessment': null,
			'tooltipOpen': true,
			'showArcConfirmation': '',
			'toggledShowMore':'',
			'internalNote':'',
			'jsHeadShow':false,
			'internal_comment': '',
		}
		this.assignAssessmentTherapyArea = this.assignAssessmentTherapyArea.bind(this)
		this.getPatient = this.getPatient.bind(this)
		this.archivePatient = this.archivePatient.bind(this)
		this.deletePatient = this.deletePatient.bind(this)
		this.savePatient = this.savePatient.bind(this)
		this.setPractice = this.setPractice.bind(this)
		this.getPatientRecord = this.getPatientRecord.bind(this)
		this.showMenu = this.showMenu.bind(this)
		this.createAssessment = this.createAssessment.bind(this)
		this.showNewAssessmentForm = this.showNewAssessmentForm.bind(this)
		this.handleAssessmentFormChange = this.handleAssessmentFormChange.bind(this)
		this.handlePatientImage = this.handlePatientImage.bind(this)
		this.toggleSelectedSessionVideo = this.toggleSelectedSessionVideo.bind(this)
		this.handleSessionFormChange = this.handleSessionFormChange.bind(this)
		this.toggle = this.toggle.bind(this)
		this.setup = this.setup.bind(this)
		this.showLatestAssessmentDetails = this.showLatestAssessmentDetails.bind(this)
		this.latestAssessment = this.latestAssessment.bind(this)
		this.getPatientAssessments = this.getPatientAssessments.bind(this)
		this.assignSessionTherapyArea = this.assignSessionTherapyArea.bind(this)
		this.assignTherapyArea = this.assignTherapyArea.bind(this)
		this.saveSession = this.saveSession.bind(this)
		this.sendSession = this.sendSession.bind(this)
		this.clearSession = this.clearSession.bind(this)
		this.showNewSessionForm = this.showNewSessionForm.bind(this)
		this.sessionSelectedTherapyArea = this.sessionSelectedTherapyArea.bind(this)
		this.sessionSelectedTherapyAreaVideos = this.sessionSelectedTherapyAreaVideos.bind(this)
		this.showEditSession = this.showEditSession.bind(this)
		this.setSessionsArray = this.setSessionsArray.bind(this)
		this.setAssessmentArray = this.setAssessmentArray.bind(this)
		this.setUpNewSession = this.setUpNewSession.bind(this)
		this.sessionClick = this.sessionClick.bind(this)
		this.handlePatientInputChange = this.handlePatientInputChange.bind(this)
		this.attachGalleryItem = this.attachGalleryItem.bind(this)
		this.attachSessionImage = this.attachSessionImage.bind(this)
		this.attachSessionInternalImage = this.attachSessionInternalImage.bind(this)
		this.removeSessionInternalImage = this.removeSessionInternalImage.bind(this)
		this.removeSessionImage = this.removeSessionImage.bind(this)
		this.removeSessionImageFromSent = this.removeSessionImageFromSent.bind(this);
		this.removeSessionInternalImageFromSent = this.removeSessionInternalImageFromSent.bind(this)
		this.deleteSession = this.deleteSession.bind(this)
		this.assessmentCategoryClick = this.assessmentCategoryClick.bind(this)
		this._renderWaypoint = this._renderWaypoint.bind(this)
		this.fetchMoreSessions = this.fetchMoreSessions.bind(this)
		this.blur = this.blur.bind(this)
		this.isEditable = this.isEditable.bind(this)
		this.addAssessmentDocument = this.addAssessmentDocument.bind(this)
		this.deleteAssessmentDocument = this.deleteAssessmentDocument.bind(this)
		this.handleChange = this.handleChange.bind(this)
		this.handleAssessmentDOAChange = this.handleAssessmentDOAChange.bind(this)
		this.getAssessmentsSessionsArray = this.getAssessmentsSessionsArray.bind(this)
		this.showAssessment = this.showAssessment.bind(this)
		this.filterBy = this.filterBy.bind(this)
		this.filterByDate = this.filterByDate.bind(this)
		this.toggleHomework = this.toggleHomework.bind(this)
		this.toggleNewSessionAssessmentMenu = this.toggleNewSessionAssessmentMenu.bind(this)
		this.toggleShowAssessment = this.toggleShowAssessment.bind(this)
		this.tooltipClose = this.tooltipClose.bind(this)
		this.showArchiveConfrimation = this.showArchiveConfrimation.bind(this)
		this.getCurrentAssessment = this.getCurrentAssessment.bind(this)
		this.toggleShowMore = this.toggleShowMore.bind(this)
		this.handleInternalNoteChange = this.handleInternalNoteChange.bind(this)
		this.addInternalNote = this.addInternalNote.bind(this)
		this.archiveActionBtn = this.archiveActionBtn.bind(this)
		this.activateActionBtn = this.activateActionBtn.bind(this)
		this.deleteActionBtn = this.deleteActionBtn.bind(this)
		this.checkIsEqual = this.checkIsEqual.bind(this);
	}

	handleChange(date) {
		this.setState({
			'patientForm': { ...this.state.patientForm, ['dob']: date }
		});
		this.setState({
			startDate: date
		});
	}

	componentDidUpdate(nextProps, nextState) {
		if (
			(nextProps.params.patientId !== this.props.params.patientId) ||
			(nextProps.app.authed !== this.props.app.authed)
		) {
			this.setState({
				gotPatients: false
			});
		}
		// console.log('User',this.props.User);
		if (this.props.User.name != nextProps.User.name) {
			console.log('Update');
			this.setup()
		}

		if (nextState.patient_sessions_array.length !== this.state.patient_sessions_array.length || !this.checkIsEqual(this.state.patient_sessions_array, nextState.patient_sessions_array)) {
			console.log('Updated sessions');
			console.log('Updated Session length:', this.state.patient_sessions_array.length);
			console.log('Current Session length:', nextState.patient_sessions_array.length);
			this.getAssessmentsSessionsArray();
		}

		if (nextState.patient_assessments_array.length !== this.state.patient_assessments_array.length || !this.checkIsEqual(this.state.patient_assessments_array, nextState.patient_assessments_array)) {
			console.log('Updated assessments');
			console.log('Updated Assessment length:', this.state.patient_assessments_array.length);
			console.log('Current Assessment length:', nextState.patient_assessments_array.length);
			this.getAssessmentsSessionsArray();
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		const { modal, notifications } = this.props;
		const { patient_sessions_array, patient_assessments_array } = this.state;
		let update = true

		if (modal && modal.isOpen && nextProps.notifications !== notifications) {
			update = false;
		}

		// if (nextProps.params.patientId === this.props.params.patientId) {
		// 	return false;
		// }

		// if (nextProps.app.authed === this.props.app.authed) {
		// 	return false;
		// }

		// if (nextProps.assessments === this.props.assessments) {
		// 	return false;
		// }

		// if (nextProps.sessions === this.props.sessions) {
		// 	return false;
		// }

		// if (nextProps.therapy_areas === this.props.therapy_areas) {
		// 	return false;
		// }

		// if (nextProps.therapy_categories === this.props.therapy_categories) {
		// 	return false;
		// }

		// if (nextProps.videos === this.props.videos) {
		// 	return false;
		// }

		return update;

		// Only update this is the modal is not open or if the notifications have changed
		// if (modal && modal.isOpen && nextProps.notifications !== notifications) {
		// 	return false
		// } else {
		// 	return true
		// }
	}

	componentWillUnmount() {
		let { User } = this.props
		eventbus.clearSubscribtions("writeGalleryIdInSession")
		unListenToUserSessionNotifications(User.uid)
		if (this.imageTimeout) {
			clearTimeout(this.imageTimeout)
		}
	}

	checkIsEqual(value, other) {

		// Get the value type
		var type = Object.prototype.toString.call(value);
	
		// If the two objects are not the same type, return false
		if (type !== Object.prototype.toString.call(other)) return false;
	
		// If items are not an object or array, return false
		if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;
	
		// Compare the length of the length of the two items
		var valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
		var otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
		if (valueLen !== otherLen) return false;
	
		// Compare two items
		var compare = function (item1, item2, _this) {
	
			// Get the object type
			var itemType = Object.prototype.toString.call(item1);
	
			// If an object or array, compare recursively
			if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
				if (!_this.checkIsEqual(item1, item2)) return false;
			}
	
			// Otherwise, do a simple comparison
			else {
	
				// If the two items are not the same type, return false
				if (itemType !== Object.prototype.toString.call(item2)) return false;
	
				// Else if it's a function, convert to a string and compare
				// Otherwise, just compare
				if (itemType === '[object Function]') {
					if (item1.toString() !== item2.toString()) return false;
				} else {
					if (item1 !== item2) return false;
				}
			}
		};
	
		// Compare properties
		if (type === '[object Array]') {
			for (var i = 0; i < valueLen; i++) {
				if (compare(value[i], other[i], this) === false) return false;
			}
		} else {
			for (var key in value) {
				if (value.hasOwnProperty(key)) {
					if (compare(value[key], other[key], this) === false) return false;
				}
			}
		}
	
		// If nothing failed, return true
		return true;
	
	};

	isEditable() {
		const { params, User } = this.props;
		return params.therapistId === User._id || !params.therapistId
	}

	handleAssessmentDOAChange(date) {
		this.setState({
			'newAssessment': { ...this.state.newAssessment, ['doa']: date }
		});
		this.setState({
			assessmentStartDate: date
		});
		// console.log(date);
	}

	handleAssessmentFormChange(e, key) {
		const { patient } = this.state;
		let val = e.target.value
		// date of assessment can't be earlier than birth
		if (key === 'doa' && patient.dob && !moment(val).isAfter(patient.dob)) {
			// val = moment(patient.dob).format('YYYY-MM-DD')
			val = moment(patient.dob)
		}
		this.setState({
			'newAssessment': { ...this.state.newAssessment, [key]: val }
		});
	}

	componentDidMount() {
		const { practiceId, patientId } = this.props.params;

		this.props.dispatch(setTitle('Therapist'))
		this.props.dispatch(fetchTherapyCategories())
		this.props.dispatch(fetchTherapyAreas())
		this.props.dispatch(fetchVideos())
		this.props.dispatch(getGalleryItemsForPatient(patientId))
		this.props.dispatch(fetchPracticeById(practiceId))
		this.setup();

		this.tooltipClose()
		document.querySelectorAll('._jsHeadShow')[0].addEventListener('scroll', this.onscroll);

		// Eventbus from MediaUpload component
		eventbus.subscribe("writeGalleryIdInSession", (result)=>{
			// save session
			this.attachGalleryItem(result.id)
		})

		// Eventbus from NewSession component
		eventbus.subscribe("removeGalleryIdInSession", (result)=>{
			// save session
			this.removeGalleryItem(result.id)
		})
	}


	async setup() {
		// console.log('Setup');
		const { dispatch, User, params } = this.props
		const { from } = this.state
		if (User.therapist || User.Owner) {
			// only this therapist or the owner of this practice can go further
			if (!User.therapist && !params.therapistId) {
				alert('Only a therapist can view this page')
				return
			}
			if (params.therapistId && !User.therapist && !User.Owner) {
				alert('Only a therapist or owner can view this page')
				return
			}
			if (!User.therapist && User.Owner && User.ownPractices.find(p => p._id === params.practiceId)) {
				alert('You need to be the owner of this practice to view this page')
				return
			}
			this.setState({
				'patientForm': {},
				'patient': {}
			})
			this.getPatient()
			this.setPractice()
			// console.log('Get Patient Record');
			const record = await this.getPatientRecord();
			// console.log('Patient Record:', record);
			if (record._id) {
				this.setState({ 'loading': true })
				await dispatch(listenToUserSessionNotifications(User.uid))
				// console.log('Get Sessions');
				const sessions = await dispatch(fetchSessions(record._id, from))
				// console.log('Get Sessions Data', sessions);
				await this.setSessionsArray()
				await this.getAssessmentsSessionsArray();
				this.setState({ 'loading': false })
			} else {
				alert('No assessments found')
				this.setState({ 'loading': false })
			}
		}
	}

	async getPatientRecord() {
		const { params, User } = this.props
		const therapistId = params.therapistId || User._id
		const { practiceId, patientId } = params;
		console.log('User: ', User);
		console.log('Therapist Id: ', therapistId);
		console.log('Params: ', params);
		console.log('Call Get Patient Record');
		const patientRecord = await this.props.dispatch(fetchTherapistPatientRecord(therapistId, practiceId, patientId));
		if (patientRecord._id) {
			// console.log('Call Get Patient Assessments');
			console.log('Patient Record Data', patientRecord);
			await this.getPatientAssessments(patientRecord._id)
		}
		this.setState({
			'patientRecord': patientRecord
		});
		return patientRecord;
	}

	async getPatientAssessments(patientRecordId) {
		let therapistId = this.props.User._id;
		console.log('Call Get Assessments');
		const assessments = await this.props.dispatch(fetchPatientAssessments(therapistId, patientRecordId));
		console.log('Patient Assessments Data:', assessments);
		await this.setAssessmentArray();
		this.setState({
			//'newSession': {...this.state.newSession, therapy_areas: latestAssessment.therapy_areas}
			'newSession': { ...this.state.newSession, therapy_areas: [] }
		});
		return assessments;
	}


	insertSessionUsers(sessionId) {
		let { dispatch } = this.props;
		let { patient } = this.state;
		let uids = [];

		patient.guardians.forEach(u => {
			uids.push(u.uid)
		});
		if(patient.parent) {
			uids.push(patient.parent.uid);
		}

		uids.forEach(uid => {
			dispatch({
				type: 'INSERT_SESSION_USER',
				payload: {
					'user': uid,
					'sessionId': sessionId
				}
			})
		})
	}

	sessionClick(session) {
		let { dispatch, videos } = this.props;
		let { sessionCommentText, patient } = this.state;
		if (!session) return

		this.setState({ 'sessionCommentText': '' });
		// add the therapist to the session users
		this.insertSessionUsers(session._id)

		dispatch(setModal('TherapistSession', null, {
			typeOfModal: 'TherapistSession',
			patient: patient,
			sessionId: session._id,
			session: session,
			videos: videos,
			removeImage: this.removeSessionImageFromSent,
			removeInternalImage: this.removeSessionInternalImageFromSent,
			commentText: sessionCommentText,
			updateCommentText: this.updateCommentText,
			activeVideoId: null,
			//addComment: this.addSessionComment,
			setActiveVideo: this.setActiveVideo,
			toggleVideoDone: this.toggleVideoDone,
			saveSession: this.saveSession,
			sendSession: this.sendSession,
			addComment: true
		}, true, 'fullscreen'))
	}

	handleSessionFormChange(e, key) {
		let val = e.target.value
		console.log(val)
		let data = { ...this.props.modal.data };
		data.session[key] = val;
		this.props.dispatch(setModal('NewSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
	}



	async deleteSession(sessionId) {
		const { User, dispatch } = this.props;
		if (confirm('Really delete this session?')) {
			await dispatch(deleteSession(User._id, sessionId));
			await this.setSessionsArray();
		}
	}

	attachGalleryItem(galleryId) {
		let data = { ...this.props.modal.data };

		data.session.gallery = data.session.gallery || [];
		data.session.gallery.push(galleryId);
		this.props.dispatch(setModal('NewSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
		// this.saveSession(false, false)
	}

	async removeGalleryItem(galleryId) {
		// console.log('Gallery ID', galleryId);
		// console.log('Props:', this.props);
		// console.log('State:', this.state);
		let data = { ...this.props.modal.data };
		// console.log('data', data);
		if (data.session !== undefined) {
			if (data.session.gallery !== undefined) {
				data.session.gallery = data.session.gallery.filter(gal => {
					return gal !== galleryId
				});
			} else {
				data.session.gallery = [];
			}
			
			if (data.typeOfModal !== undefined && data.typeOfModal === 'TherapistSession') {
				// Do nothing
			} else {
				console.log('Update new Session modal')
				this.props.dispatch(setModal('NewSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))	
			}
		}
	}

	attachSessionImage(img) {
		let data = { ...this.props.modal.data };

		data.session.images = data.session.images || [];
		data.session.images.push(img);
		this.props.dispatch(setModal('NewSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
		this.saveSession(false, false)
	}
	attachSessionInternalImage(img) {
		console.log('Patient Save Image');
		console.log(img);
		let data = { ...this.props.modal.data };

		data.session.internal_images = data.session.internal_images || [];
		data.session.internal_images.push(img);
		this.props.dispatch(setModal('NewSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
		this.saveSession(false, false)
	}

	removeSessionImage(img) {
		let data = { ...this.props.modal.data };
		console.log('data', data);
		data.session.images = data.session.images || [];
		data.session.images = data.session.images.filter(i => {
			return i.orig !== img.orig
		})
		this.props.dispatch(setModal('NewSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
		this.saveSession(data.session.sent)
	}

	removeSessionInternalImage(img) {
		let data = { ...this.props.modal.data };
		console.log('data', data);
		data.session.internal_images = data.session.internal_images || [];
		data.session.internal_images = data.session.internal_images.filter(i => {
			return i.orig !== img.orig
		})
		this.props.dispatch(setModal('NewSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
		this.saveSession(data.session.sent)
	}

	removeSessionImageFromSent(img) {
		let data = { ...this.props.modal.data };
		let { sessions } = this.props;
		// from the sent popup there is a sessionId prop, not a session object
		data.session = sessions[data.sessionId]
		data.session.images = data.session.images || [];
		data.session.images = data.session.images.filter(i => {
			return i.orig !== img.orig
		})
		this.props.dispatch(setModal('TherapistSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
		this.saveSession(true, false)
	}

	removeSessionInternalImageFromSent(img) {
		debugger
		let data = { ...this.props.modal.data };
		let { sessions } = this.props;
		// from the sent popup there is a sessionId prop, not a session object
		data.session = sessions[data.sessionId]
		data.session.internal_images = data.session.internal_images || [];
		data.session.internal_images = data.session.internal_images.filter(i => {
			return i.orig !== img.orig
		});
		this.props.dispatch(setModal('TherapistSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
		this.saveSession(true, false)
	}

	setUpNewSession() {
		this.setState({
			//newSession: {...cleanNewSession, assessment_areas: this.latestAssessment().assessment_areas}
			'newSession': { ...cleanNewSession, therapy_areas: [] }
		})
	}

	async saveSession(sent = false, clear = true) {
		let { patientRecord } = this.state;
		let s = {
			...this.props.modal.data.session,
			patient: patientRecord.patient,
			therapist: patientRecord.therapist,
			practice: patientRecord.practice,
			patientRecord: patientRecord._id,
			sent: sent
		}
		if (sent) {
			s.dateSent = new Date()
		}
		await this.props.dispatch(saveSession(s))
			.then((r) => {
				this.setSessionsArray()
				this.getPatientRecord()
				if (!clear) {
					let module = sent ? 'TherapistSession' : 'NewSession';
					let data = { ...this.props.modal.data };
					if (data.session !== undefined && r.payload !== undefined && r.payload._id !== undefined) {
						data.session._id = r.payload._id;
						this.props.dispatch(setModal(module, null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
					}
				}
			})
		this.toggle('newSessionFormOpen', false)
		// eslint-disable-next-line
		clear && this.clearSession()

	}

	sendSession() {
		this.saveSession(true)
	}

	clearSession() {
		this.setState({
			'newSession': { ...cleanNewSession, therapy_areas: [] }
		})
	}


	setSessionsArray() {
		const { sessions } = this.props;
		//sort
		let sessions_array = Object.values(sessions).sort((a, b) => {
			return (b.date > a.date) ? 1 : ((a.date > b.date) ? -1:0);
		});
		this.setState({
			'patient_sessions_array': sessions_array
		})
		return true;
	}

	setAssessmentArray() {
		const { assessments } = this.props;
		let assessments_array = Object.values(assessments).sort((a, b) => {
			return (b.doa > a.doa) ? 1 : ((a.doa > b.doa) ? -1:0);
		});
		this.setState({
			'patient_assessments_array': assessments_array
		});
		return true;
	}

	setPractice() {
		if (this.props.User.therapistPractices) {
			let practice = this.props.User.therapistPractices.find(p => p._id === this.props.params.practiceId);
			if (practice) {
				this.props.dispatch(setPractice(practice))
			}
		}
	}

	assignSessionTherapyArea(area) {
		let { session } = this.props.modal.data;
		let areaId = area._id;
		let data = {};
		let therapy_areas;
		if (session.therapy_areas.indexOf(areaId) === -1) {
			// it's not here, add it
			therapy_areas = session.therapy_areas.concat([areaId])
		} else {
			// it's here, remove it
			therapy_areas = session.therapy_areas.filter(i => i !== areaId)
		}
		let selected_areas = this.sessionSelectedTherapyArea(therapy_areas)
		let selected_areas_videos = this.sessionSelectedTherapyAreaVideos(therapy_areas)
		data = {
			...this.props.modal.data,
			selected_areas: selected_areas,
			selected_areas_videos: selected_areas_videos,
			session: {
				...this.props.modal.data.session,
				therapy_areas: therapy_areas
			}
		}
		this.props.dispatch(setModal('NewSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
	}

	sessionSelectedTherapyArea(areas) {
		let { therapy_areas } = this.props;
		return areas.map(areaId => therapy_areas[areaId] || {})
	}

	sessionSelectedTherapyAreaVideos(areas) {
		let { therapy_areas } = this.props;

		return [...new Set(areas.map(areaId => {
			return therapy_areas[areaId] ? therapy_areas[areaId].videos : []
		})
			.reduce((a, b) => a.concat(b), []))]
	}

	toggleSelectedSessionVideo(video) {
		let { session } = this.props.modal.data;
		let videoId = video;
		let data = {};
		let videos;
		if (session.videos.indexOf(videoId) === -1) {
			// it's not here, add it
			videos = session.videos.concat([videoId])
		} else {
			// it's here, remove it
			videos = session.videos.filter(i => i !== videoId)
		}
		this.saveSession(false, false);
		data = {
			...this.props.modal.data,
			session: {
				...this.props.modal.data.session,
				videos: videos
			}
		}
		this.props.dispatch(setModal('NewSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
	}

	assignAssessmentTherapyArea(area) {
		//this.assignTherapyArea('newAssessment', area)
		this.setState({
			'newAssessment': this.assignTherapyArea('newAssessment', area)
		});
	}

	assignTherapyArea(obj, area) {
		let areaId = area._id;
		let stateObj = this.state[obj];
		let data = {};
		let therapy_areas;

		if (stateObj.therapy_areas.indexOf(areaId) === -1 && areaId !== undefined) {
			// it's not here, add it
			therapy_areas = stateObj.therapy_areas.concat([areaId]);
		} else {
			therapy_areas = stateObj.therapy_areas.filter(i => i !== areaId);
		}

		data = {
			...this.state[obj],
			therapy_areas: therapy_areas
		}

		return data;
	}

	savePatient(patient = this.state.patientForm) {
		this.props.dispatch(savePatient(this.props.User._id, this.props.app.practice._id, patient))
			.then(() => {
				console.log('Updated and fetch patient information.');
				this.setState({
					'gotPatients': false
				});
				this.getPatient(true);
			});
	}

	handlePatientInputChange(e, att) {
		this.setState({
			'patientForm': { ...this.state.patientForm, [att]: e.target.value }
		})
	}

	handlePatientImage(img) {
		this.setState({
			'patientForm': { ...this.state.patientForm, picture: img }
		})
		this.imageTimeout = setTimeout(() => {
			this.setState({
				'update': Math.random()
			})
		}, 5000)
	}

	getPatient(forceFetch = false) {
		let patient = this.props.patients.find(p => p._id === this.props.params.patientId);
		this.props.dispatch(setTitle(``))
		if ((!this.state.gotPatients && !patient) || forceFetch) {
			// get patients
			this.props.dispatch(fetchTherapistPatients(this.props.User._id))
				.then(() => {
					patient = this.props.patients.find(p => p._id === this.props.params.patientId);
					// this.props.dispatch(setTitle(`${patient.firstName || ''} ${patient.lastName || ''}`))
					this.setState({
						'patient': patient,
						'patientForm': patient,
						'gotPatients': true
					});
				})
		} else {
			// this.props.dispatch(setTitle(`${patient.firstName || ''} ${patient.lastName || ''}`))
			this.setState({
				'patient': patient,
				'patientForm': patient,
				'startDate': moment(patient.dob),
			});
		}
	}

	deletePatient() {
		let { patient } = this.state;
	}

	tooltipClose(){
		setTimeout(() => {
			this.setState({
				tooltipOpen: false
			})
		}, 5000);
	}

	showArchiveConfrimation(){
		this.setState({
			showArcConfirmation: 'show'
		})
		
		setTimeout(() => {
			this.setState({
				showArcConfirmation: 'hide'
			})
		}, 3000);

		setTimeout(() => {
			this.setState({
				showArcConfirmation: ''
			})
		}, 5000);
	}

	archivePatient() {
		let { patient } = this.state;
		let patientUpdate = patient;
		if (patient.archived) {
			this.props.dispatch(unarchiveTherapistPatient(this.props.User._id, patient._id))
				.then(() => {
					patientUpdate = this.props.patients.find(p => p._id === this.props.params.patientId);
					this.setState({
						'patient': patientUpdate,
						'patientForm': patientUpdate,
						'gotPatients': true
					});
					this.showArchiveConfrimation();
				});
		} else {
			// get patients
			this.props.dispatch(archiveTherapistPatient(this.props.User._id, patient._id))
				.then(() => {
					patientUpdate = this.props.patients.find(p => p._id === this.props.params.patientId);
					this.setState({
						'patient': patientUpdate,
						'patientForm': patientUpdate,
						'gotPatients': true
					});
					this.showArchiveConfrimation();
				})
		}
	}

	toggle(key, val) {
		this.setState({
			[key]: typeof val === 'undefined' ? !this.state[key] : val
		})

		if(key === 'editPatientOpen' || key === 'active_category'){
			if (this.state.jsHeadShow === false) {
				document.querySelectorAll('._jsHeadShow').forEach((domNode)=>{domNode.classList.add('overflowHide')})
				this.setState({'jsHeadShow':true})
			} else {
				document.querySelectorAll('._jsHeadShow').forEach((domNode)=>{domNode.classList.remove('overflowHide')})
				this.setState({'jsHeadShow':false})
			}
		} else {
			document.querySelectorAll('._jsHeadShow').forEach((domNode)=>{domNode.classList.remove('show')})
			this.setState({'jsHeadShow':false})
		}
	}

	addAssessmentDocument(doc, assessment) {
		const { User, app } = this.props;
		const { newAssessment, patient, patientRecord } = this.state;
		const thisAssessment = assessment || newAssessment;
		const documents = (thisAssessment.documents != undefined) ? thisAssessment.documents: [];
		const updateAssessment = {
			...thisAssessment,
			patient: patient._id,
			practice: app.practice._id,
			practice_type: app.practice.practice_type,
			therapist: User._id,
			patientRecord: patientRecord._id,
			documents: [...documents, doc]
		};
		// console.log('Assessment', thisAssessment);
		// console.log('documents', documents);
		// console.log('Update Assessment', updateAssessment);

		if (assessment) {
			this.props.dispatch(createAssessment(User._id, updateAssessment))
				.then(r => {
					// eslint-disable-next-line
					if (assessment) {
						this.setState({ 'currenetAssessment': r})
					} else {
						this.setState({ 'newAssessment': r })
					}
					this.getPatientRecord()
					// return r;
				});
		} else {
			this.setState({ 'newAssessment': updateAssessment });
		}
	}

	getCurrentAssessment() {
		const { currenetAssessment } = this.state;
		const assessment = {
			created: currenetAssessment.created,
			description: currenetAssessment.description,
			doa: currenetAssessment.doa,
			documents: currenetAssessment.documents,
			id: currenetAssessment.id,
			internal_notes: currenetAssessment.internal_notes,
			internal_notes_array: currenetAssessment.internal_notes_array,
			modified: currenetAssessment.modified,
			patient: currenetAssessment.patient._id,
			patientRecord: currenetAssessment.patientRecord._id,
			practice: currenetAssessment.practice._id,
			therapist: currenetAssessment.therapist._id,
			therapy_areas: currenetAssessment.therapy_areas,
			__v: currenetAssessment.__v,
			_id: currenetAssessment._id
		}

		return assessment;
	}

	deleteAssessmentDocument(doc, newAssessment) {
		const { User, app } = this.props;
		const { patient, patientRecord } = this.state;
		const assessment = newAssessment || this.getCurrentAssessment();
		
		const documents = assessment.documents.filter(d => d.name !== doc.name);
		const updateAssessment = {
			...assessment,
			patient: patient._id,
			practice: app.practice._id,
			practice_type: app.practice.practice_type,
			therapist: User._id,
			patientRecord: patientRecord._id,
			documents: documents
		};
		// console.log('Assessment', assessment);
		// console.log('documents', documents);
		// console.log('Update Assessment', updateAssessment);

		if (!confirm(`Really delete ${doc.name}?`))
			return

		this.props.dispatch(createAssessment(User._id, updateAssessment))
			.then(r => {
				if (newAssessment) {
					this.setState({ 'newAssessment': r });
				} else {
					this.setState({
						'currenetAssessment': {...this.state.currenetAssessment, documents: r.documents}
					});
				}
				deleteDocument(doc);
				this.setup()
			});
	}

	createAssessment(assessment) {
		let { User, app } = this.props;
		let { patient, patientRecord } = this.state;
		this.toggle('newAssessmentFormOpen')
		this.props.dispatch(
			createAssessment(User._id, {
				...assessment,
				patient: patient._id,
				practice: app.practice._id,
				practice_type: app.practice.practice_type,
				therapist: User._id,
				patientRecord: patientRecord._id
			})
      	)
      	.then(r => {
			delete cleanNewAssessment.internal_notes;
			this.setState({ 'newAssessment': cleanNewAssessment });
        	this.getPatientRecord();
      	});
	}

	toggleNewSessionAssessmentMenu() {
		this.setState({
			newSessionAssessmentMenu: !this.state.newSessionAssessmentMenu
		});
		document.querySelectorAll('._jsHeadShow').forEach((domNode)=>{domNode.classList.add('show')});
		this.setState({'jsHeadShow':true});
	}

	archiveActionBtn(patient) {
		if (window.confirm('Are you sure you want archive this patient?')) {
			this.archivePatient(patient);
		}
	}

	activateActionBtn(patient) {
		if (window.confirm('Are you sure you want activate this patient?')) {
			this.archivePatient(patient);
		}
	}

	deleteActionBtn(patient) {
		if(window.confirm('Are you sure you want delete this patient?')) {
			this.deletePatient(patient)
		}
	}

	actionButtons() {
		const {
			patient,
			patient_sessions_array,
			patient_assessments_array,
		} = this.state;

		if ((patient.guardians !== undefined && patient.guardians.length > 0) ||
			(patient.therapists !== undefined && patient.therapists.length > 0) ||
			(patient.therapy_areas !== undefined && patient.therapy_areas.length > 0) ||
			(patient.parent !== null) || 
			(patient_sessions_array.length > 0) ||
			(patient_assessments_array.length > 0)) {
				if (patient.archived === undefined || patient.archived === false) {
					/* This should be set to unarchived */
					return <a onClick={() => this.archiveActionBtn(patient)}>
							<img className="archiveSVG" src={archiveSVG} alt=""/>
						</a>
				} else {
					/* This should be set to archived */
					return <a onClick={() => this.activateActionBtn(patient)} >
						<img className="unArchiveSVG" src={unArchiveSVG} alt=""/>
						<div>
						<Tooltip
							className="md-list archiveTooltip"
							title="Archive or Activate"
							delay={1}
							hideDelay={4}
							open={this.state.tooltipOpen}
							trigger="manual"
							position="bottom-start"
							arrow={true}
							unmountHTMLWhenHide={true}
						></Tooltip>
						</div>
					</a>
				}
		} else {
			return <a onClick={() => this.deleteActionBtn(patient)} >
				<img src={deleteSVG} alt=""/>
			</a>;
		}

	}

	showMenu() {
		const {
			newSession,
			patient,
			newSessionAssessmentMenu,
			patientRecord,
		} = this.state;
			window.addEventListener('unload', function () {});
			return (<div className="row patientMenu marginless">
						{patientRecord._id ?
						<div className="fixedButton " style={{display: (patient.archived !== undefined && patient.archived === true) ? 'none' : 'inline-block'}}>

							<div className=" patientButtonNew" onClick={() => {
									this.clearSession();
									this.showNewSessionForm(newSession);
									this.toggleNewSessionAssessmentMenu();
								}}> <img src={plusSVG} alt="New Session"/> 
							</div>
						</div>
						: '' }
				<div className="page-menu  row fill ">
					<div className={"archiveConfirmation " + this.state.showArcConfirmation}>
					{(patient.archived) ?
						<p>Patient has been Archived</p>:
						<p>Patient has been Activated</p>}
						{/* <p>Patient has been Deleted</p> */}
					</div>

					<div className="patientPhoto">
						{patient.picture && <Avatar pic={`${patient.picture.thumb}`} />}
					</div>
					<div className="patientInfo">
						<p>{patient.firstName} {patient.lastName}</p>
						<small>{(patient.parent) && patient.parent.name}</small>
						<small>Date of birth: {moment(patient.dob).format('YYYY/MM/DD')}</small>
						<small>{patient.archived}</small>
					</div>
					<div className="patientButtons">
						<div className="buttons">
							<a onClick={() => this.toggle("editPatientOpen")} >EDIT</a>
							<a className={"newAssesment"} style={{display: (patient.archived !== undefined && patient.archived === true) ? 'none' : 'inline-block'}} onClick={() => {
									this.setState({ 'newAssessment': cleanNewAssessment });
									this.toggle('newAssessmentFormOpen');
									this.toggleNewSessionAssessmentMenu();
									// this.addClassToAppContent();
								}}>+ ASSESSMENT</a>
							{ this.actionButtons() }
						</div>
					</div>

				</div>
			</div>
			)
	}

	showNewAssessmentForm() {
		let { newAssessment, patient } = this.state;
		return this.state.newAssessmentFormOpen ? <div>
			<AssessmentForm
				close={
					(event) => {
						console.log(event)
						this.toggle("newAssessmentFormOpen");
					}
				}
				assessment={newAssessment}
				handleFormChange={this.handleAssessmentFormChange}
				addDocument={this.addAssessmentDocument}
				deleteDocument={this.deleteAssessmentDocument}
				patient={patient}
				assignTherapyArea={this.assignAssessmentTherapyArea}
				assessmentStartDate={this.state.assessmentStartDate}
				handleDOAChange={this.handleAssessmentDOAChange}
				save={() => this.createAssessment(this.state.newAssessment)} />
		</div> : null;
	}

	showNewSessionForm(session) {
		let { patient, newSessionSelectTherapyAreasOpen, newSessionSelectVideosOpen, patientRecord } = this.state;
		let { videos, therapy_areas, dispatch } = this.props;
		if (session._id) {
			this.setState({ 'whichSession': 'store' })
		} else {
			this.setState({ 'whichSession': 'state' })
		}

		dispatch(setModal('NewSession', null, {
			therapy_areas: therapy_areas,
			patient: patient,
			attachImage: this.attachSessionImage,
			removeImage: this.removeSessionImage,
			attachInternalImage: this.attachSessionInternalImage,
			removeInternalImage: this.removeSessionInternalImage,
			patientRecord: patientRecord,
			toggleSessionAreasOpen: this.toggle,
			handleSessionFormChange: this.handleSessionFormChange,
			assignSessionTherapyArea: this.assignSessionTherapyArea,
			saveSession: this.saveSession,
			sendSession: this.sendSession,
			handleToggleSelectedSessionVideo: this.toggleSelectedSessionVideo,
			session: session,
			selected_areas: this.sessionSelectedTherapyArea(session.therapy_areas),
			selected_areas_videos: this.sessionSelectedTherapyAreaVideos(session.therapy_areas),
			videos: videos,
			newSessionSelectVideosOpen: newSessionSelectVideosOpen,
			newSessionSelectTherapyAreasOpen: newSessionSelectTherapyAreasOpen
		}, true, 'fullscreen'))
	}

	assessmentCategoryClick(category) {
		this.toggle('active_category', category)
	}


	showLatestAssessmentDetails() {
		let { therapy_areas, therapy_categories, User } = this.props;
		let { patient, active_category } = this.state;

		if (!therapy_areas) return []


		const assessment = this.latestAssessment();
		const documents = (assessment.documents != undefined) ? documents: [];
		const categoryAreas = () => assessment.therapy_areas
			.filter(areaId => {
				if (!therapy_areas[areaId]) return []
				return therapy_areas[areaId] ? therapy_areas[areaId].categories.indexOf(active_category) !== -1 : false
			}
			).map(areaId => therapy_areas[areaId])
		const age = () => {
			if (patient.dob && assessment) {
				let assessmentDate = assessment.doa || assessment.modified
				let duration = moment.duration(moment(assessmentDate).diff(patient.dob))
				return duration.years() + ' years ' + duration.months() + ' months'
			} else {
				return ''
			}
		}

		let interalNotes = '';

		if (User.therapist) {
			if (assessment.internal_notes.length > 0) {
				interalNotes = <span id="internalNotesOpenAssesment"><h4>Internal Notes</h4><p>{assessment.internal_notes}</p></span>
			} else {
				interalNotes = <span id="internalNotesOpenAssesment"><h4>Internal Notes</h4><p>{assessment.internal_notes}</p></span>
			}
		}

		if (assessment) {


			return <div className="card wide assessment marginless">
				<div className="card-header">
					<a className="link right" onClick={() => this.toggle("showAssessment")}>Close</a>Latest Assessment
				</div>

				<div className="card-content">
					<table className="data" >
						<tbody>
							<tr>
								<th width="30%">Date</th>
								<td>{assessment.doa ? moment(assessment.doa).format('ddd Do of MMM YYYY') : moment(assessment.modified).format('ddd Do of MMM YYYY')}</td>
							</tr>
							<tr>
								<th width="30%">Age</th>
								<td>{age()}</td>
							</tr>
						</tbody>
					</table>
					<h4>Parent Notes</h4>
					<p>{assessment.description}</p>
					{interalNotes}
					<span className="internalNotes">
					<h4>Internal Comments</h4>
					{ assessment.internal_notes_array.map(( note, key ) => 
						( <p key={`note-key-${key}`} >{note}</p> )
						)}
						<div id="addInternalNote" className="addInternalNote">
	                        <textarea name="addNote" id="addNote" value={ this.state.internal_comment} onChange={this.handleInternalNoteChange} placeholder="Add internal comment"></textarea>
	                        <button onClick={ () => {this.addInternalNote()} }>Add<span> +</span></button>
	                    </div>
					</span>
				</div>
				<div className="card-content">
					<div className="md-body1">Therapy areas</div>
					<ShowCategories
						active_category={active_category}
						click={this.assessmentCategoryClick}
						therapy_areas={assessment.therapy_areas.map(areaId => therapy_areas[areaId])}
						therapy_categories={therapy_categories}
					/>
					<CategoryAreas active_category={active_category} therapy_areas={categoryAreas()} />

				</div>

				<div className="card-content">
					<div className="md-body1">
						Documents
						</div>
					{(documents && documents.length) ? documents.map(doc => {

						return <p key={`doc-${doc.name}`}>
							<a className="link right" onClick={() => this.deleteAssessmentDocument(doc)}><small>Delete</small></a>
							<FileImg /><a href={`${doc.url}`} target="_new">{doc.name}</a>
						</p>
					}) : null}

				</div>
				<div>
					<div className="right">
						<DocumentUpload update={true} callback={d => this.addAssessmentDocument(d, assessment)} path={`documents/assessments/patients/${patient._id}/`} />
						<br /><br />
					</div>
				</div>
			</div>
		} else {
			return null
		}
	}

	showEditSession(session) {
		this.showNewSessionForm(session)
	}

	latestAssessment() {
		let { assessments } = this.props;
		let { patientId } = this.props.params;
		if (assessments && Object.keys(assessments).length) {
			// get this patient record's assessments
			let this_assessments = Object.values(assessments)
				.filter(r => r.patient === patientId);
			// get the keys and sort them desc
			let this_assessments_keys = this_assessments
				.map(a => a._id)
				.slice(0)
				.sort((a, b) => {
					return a < b ? 1 : -1
				});
			// return the highest _id assessment
			let latestId = this_assessments_keys[0]

			return assessments[latestId];
		} else {
			return null
		}
	}

	toggleShowAssessment(assessment) {
		this.setState({
			showAssessment: true,
			currenetAssessment: assessment,
			jsHeadShow:true
		})

		document.querySelectorAll('._jsHeadShow').forEach((domNode)=>{domNode.classList.add('show')})
	}

	 addInternalNote() {
	 	let { currenetAssessment } = this.state;

        if (currenetAssessment.internal_notes_array === undefined) {
          currenetAssessment.internal_notes_array = []
        }

        if (this.state.internal_comment !== '') {
	      currenetAssessment.internal_notes_array.push(this.state.internal_comment)
	      // currenetAssessment.internal_notes = ''
          this.setState({internal_comment:''})
      	}
    }

    handleInternalNoteChange(event) {
        this.setState({internal_comment: event.target.value});
      }

	showAssessment() {
		let { therapy_areas, therapy_categories, User } = this.props;
		let { patient, active_category, currenetAssessment } = this.state;

		if (!therapy_areas) return []

		const categoryAreas = () => currenetAssessment.therapy_areas
			.filter(areaId => {
				if (!therapy_areas[areaId]) return []
				return therapy_areas[areaId] ? therapy_areas[areaId].categories.indexOf(active_category) !== -1 : false
			}
			).map(areaId => therapy_areas[areaId])
		const age = () => {
			if (patient.dob && currenetAssessment) {
				let assessmentDate = currenetAssessment.doa || currenetAssessment.modified
				let duration = moment.duration(moment(assessmentDate).diff(patient.dob))
				return duration.years() + ' years ' + duration.months() + ' months'
			} else {
				return ''
			}
		}

		let interalNotes = '';

		if (User.therapist) {
			if (currenetAssessment.internal_notes !== undefined && currenetAssessment.internal_notes.length > 0) {
				interalNotes = <span id="internalNotesOpenAssesment"><h4>Internal Notes</h4><p>{ReactHtmlParser(currenetAssessment.internal_notes)}</p></span>
			} else {
				interalNotes = <span id="internalNotesOpenAssesment"><h4>Internal Notes</h4><p>{ReactHtmlParser(currenetAssessment.internal_notes)}</p></span>
			}
		}

		if (currenetAssessment) {

			return <div id="assesmentFormScroll" className="assesmentFormScroll"><div className="card assessmentView">
				<div className="card-header">
					<div className="headerText">Assessment</div>
					<a className="link" onClick={() => this.toggle("showAssessment")}>&times;</a>
				</div>

				<div className="card-content">
					<table className="data" >
						<tr>
							<th width="30%">Date of Assessment</th>
							<td>{currenetAssessment.doa ? moment(currenetAssessment.doa).format('ddd Do of MMM YYYY') : moment(currenetAssessment.modified).format('ddd Do of MMM YYYY')}</td>
						</tr>
						<tr>
							<th width="30%">Age</th>
							<td>{age()}</td>
						</tr>
					</table>
					<span>
						<h4>Parent Notes</h4>
						<p>{currenetAssessment.description}</p>
					</span>
					{interalNotes}
					<span className="internalNotes">
					<h4>Internal Comments</h4>
					{ currenetAssessment.internal_notes_array.map(( note, key ) => 
						( <p key={`note-key-${key}`} >{note}</p> )
						) }
						<div id="addInternalNote" className="addInternalNote">
	                        <textarea name="addNote" id="addNote" value={ this.state.internal_comment} onChange={this.handleInternalNoteChange} placeholder="Add internal comment"></textarea>
	                        <button onClick={ () => {this.addInternalNote()} }>Add<span> +</span></button>
	                    </div>
					</span>

				</div>
				<div className="card-content">
					<div className="md-body1">Therapy areas</div>
					<ShowCategories
						active_category={active_category}
						click={this.assessmentCategoryClick}
						therapy_areas={currenetAssessment.therapy_areas.map(areaId => therapy_areas[areaId])}
						therapy_categories={therapy_categories}
					/>
					<CategoryAreas active_category={active_category} therapy_areas={categoryAreas()} />

				</div>

				<div className="card-content">
					<div className="md-body1">
						Documents
						</div>
					{(currenetAssessment.documents && currenetAssessment.documents.length) ? currenetAssessment.documents.map(doc => {

						return <p key={`doc-${doc.name}`}>
							<a className="link right" onClick={() => this.deleteAssessmentDocument(doc)}><small>Delete</small></a>
							<FileImg /><a href={`${doc.url}`} target="_new">{doc.name}</a>
						</p>
					}) : null}

				</div>
				<div>
					<div className="right">
						<DocumentUpload update={true} callback={d => this.addAssessmentDocument(d, currenetAssessment)} path={`documents/assessments/patients/${patient._id}/`} />
						<br /><br />
					</div>
				</div>
			</div>
			</div>
		} else {
			return null
		}
	}

	fetchMoreSessions() {
		const { from, patientRecord } = this.state;
		const { dispatch } = this.props
		if (!patientRecord._id) return
		this.setState({ 'loading': true })

		dispatch(fetchSessions(patientRecord._id, from + 1))
			.then(sessions => {
				this.setSessionsArray()
				if (!sessions.length) {
					this.setState({ 'noMoreSessions': true })
				}
				this.setState({ 'loading': false, 'from': from + 1 })
			})
	}

	blur(val) {
		this.setState({
			'blur': val
		})
	}


	_renderWaypoint() {
		const { loading, noMoreSessions } = this.state;
		if (noMoreSessions) {
			return <div><p><br />No more sessions</p> </div>
		}
		return (
			loading ? <div>Loading ... </div> : <Waypoint
				onEnter={this.fetchMoreSessions}
			/>
		)
	}

	filterBy(event) {
		this.setState({
			filterBy: event.target.value
		});
	}

	filterByDate(date) {
		this.setState({
			filterDate: date
		});
	}

	toggleHomework(id) {
		let homework = (this.state.homework === id) ? null : id;
		this.setState({
			homework: homework
		});
	}

	getAssessmentsSessionsArray() {
		let {
			patient_sessions_array,
			patient_assessments_array,
			filterBy,
			filterDate
		} = this.state;
		console.log('Get Assessments sessions array call.');
		let assessmentsSessionsArray = [];
		const checkDate = filterDate !== null ? filterDate.format('YYYY-MM-DD'): null;
		
		if (patient_assessments_array && patient_assessments_array.length && (filterBy === 'all' || filterBy === 'assessments')) {
			patient_assessments_array.forEach(assessment => {
				const tempDate = (assessment.doa !== null) ? assessment.doa : assessment.modified;
				if ((filterDate === null) || (filterDate !== null && checkDate >= filterDate)) {
					assessmentsSessionsArray.push({
						'type': 'assessment',
						'date': tempDate,
						'data': assessment
					});
				}
			});
		}

		if (patient_sessions_array && patient_sessions_array.length && (filterBy === 'all' || filterBy === 'assessments')) {
			patient_sessions_array.forEach(session => {
				const tempDate = session.created;
				if ((filterDate === null) || (filterDate !== null && checkDate >= filterDate)) {
					assessmentsSessionsArray.push({
						'type': 'session',
						'date': tempDate,
						'data': session
					});
				}
			});
		}
		assessmentsSessionsArray.sort(function (a, b) {
			return (b.date > a.date) ? 1 : ((a.date > b.date) ? -1:0);
		});
		this.setState({ patient_session_assessments_array: assessmentsSessionsArray });
		return assessmentsSessionsArray;
	}

	toggleShowMore(id) {
		if (this.state.toggledShowMore === id){
			this.setState({ toggledShowMore:'' })
		} else {
			this.setState({ toggledShowMore:id })
		}
	}

	render() {
		let {
			blur,
			patientForm,
			showAssessment,
			patientRecord,
			newAssessmentFormOpen,
			editPatientOpen,
			update,
			startDate,
			filterBy,
			filterDate,
			homework,
			loading,
			patient_session_assessments_array
		} = this.state;
		let { notifications, videos, therapy_categories, User, gallery } = this.props;
		// console.log(this.props);
		let practice = null;
		if (this.props.User.therapistPractices) {
			practice = this.props.User.therapistPractices.find(p => p._id === this.props.params.practiceId);
		}

		// console.log(this.props)
		if (loading) {
			const divStyle = {
				'paddingTop': '50px',
				'fontSize': '.4em',
				'position': 'fixed',
				'transform': 'translate(-50%, -50%)',
				'top': '40%',
				'left': '50%',
				'display': 'flex',
				'flexDirection': 'column',
				'alignItems': 'center',
				'justifyContent': 'center'
			};
			
			// Need to style loading
			return (<div>
				<main className={"main"}>
					<div className="padding">
						<h4 style={divStyle}>
							<img src={loaderImg} alt=""/>
							<small>Loading</small>
						</h4>
					</div>
				</main>
			</div>);
		}
		
		return (
			<div>
				<Sidenav ref="rightNav" User={User.User} callback={this.blur} className="right" onLogout={this.logout} >
					<div>
						<div className="side-nav__content">
							<br /><br /><br />
							<div className="padding">
								{this.isEditable() ? (
									<div className="fill link row" onClick={() => {
										this.setState({ 'newAssessment': cleanNewAssessment })
										this.toggle('newAssessmentFormOpen'); this.refs.rightNav.closeMenu()
									}}>
										<div className={"md-button-fab dark add open-close  " + (!newAssessmentFormOpen && 'close')}>+</div>
										<div className="fill padding ">Assessment</div>
									</div>) : null}
							</div>
							<ul>
								<li>
									<a className="link " onClick={() => { this.toggle("showAssessment"); this.refs.rightNav.closeMenu() }}>Last assessment</a>
								</li>
								{this.isEditable() ? (
									<li>
										<a className="link " onClick={() => { this.toggle('editPatientOpen'); this.refs.rightNav.closeMenu() }}>Edit Patient</a>
									</li>) : null}
							</ul>
						</div>
					</div>
				</Sidenav>
				<main className={"main " + (blur ? ' blur' : '')}>
					{this.showMenu()}
					<br />
					<div className="padding">
						{showAssessment && <div>{this.showAssessment()}<br /></div>}
						{this.showNewAssessmentForm()}

						{editPatientOpen && <div className="editPatientCard">
							<div className="card  marginless">
								<div className="card-header">
									<div className="cardHeaderText">
										Edit patient
									</div>
									<a className="link" onClick={() => this.toggle("editPatientOpen")}>&times;</a>
								</div>
								<div className="cardContent">
									<PatientDetailsForm
										update={update}
										handlePatientImage={this.handlePatientImage}
										handleInputChange={this.handlePatientInputChange}
										hide={{ firstName: true, lastName: true, middleName: true }}
										patient={patientForm}
										startDate={startDate}
										handleChange={(date) => {

											this.handleChange(date)
										}}
										handleSubmit={() => {
											this.savePatient(patientForm);
											this.toggle('editPatientOpen');
										}
										} />
								</div>
							</div>
						</div>
						}

						<div className=" ">
							{patientRecord._id && <PatientSessions
								{...this.props}
								practice={practice}
								isEditable={this.isEditable()}
								patient_sessions_array={patient_session_assessments_array}
								handleEdit={this.showEditSession}
								handleDelete={this.deleteSession}
								toggleShowAssessment={this.toggleShowAssessment}
								therapy_categories={therapy_categories}
								patient={patientForm}
								notifications={notifications.sessions}
								videos={videos}
								openClick={this.sessionClick}
								patientRecord={patientRecord}
								filterBy={this.filterBy}
								filter={filterBy}
								filterDate={filterDate}
								filterByDate={this.filterByDate}
								homework={homework}
								toggled={this.state.toggledShowMore}
								toggleShowMore={this.toggleShowMore}
								toggleHomework={this.toggleHomework}
								gallery={gallery}>
							</PatientSessions>}
						</div>

						<div><p><br /></p> </div>
					</div>
				</main>
			</div>
		)
	}
}

export default withRouter(connect(mapStateToProps)(TherapistPatient));



// WEBPACK FOOTER //
// ./src/components/therapist/TherapistPatient.jsx